import { useMemo } from 'react';
import { Column, FilterProps } from 'react-table';

import DefaultInputFilter from 'components/Table/DefaultInputFilter';
import { TableHeadStyle } from 'styles/Typography';
import { ApptOption } from 'types/apptOptions';
import { getNewColumnWidth } from 'utils/table';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';

export const useApptOptionsColumns = ({
  lastColumn,
}: {
  lastColumn?: Column<ApptOption>;
}) => {
  const { t } = useCommonTranslation();

  return useMemo(() => {
    return [
      {
        Header: t('appointment-options'),
        accessor: 'name',
        cellStyle: TableHeadStyle,
        width: getNewColumnWidth(20),
        disableResizing: true,
        style: {
          flex: 1,
        },
        Filter: (props: FilterProps<object>) => (
          <DefaultInputFilter
            {...props}
            inputProps={{
              placeholder: t('appointment-options'),
            }}
          />
        ),
      },
      lastColumn,
    ] as Column<ApptOption>[];
  }, [t, lastColumn]);
};
